module.exports = __webpack_public_path__ + "static/media/launch.b7554392.svg";